module.exports = __webpack_public_path__ + "static/coworking3-548b71a38bbd9a3ef34f9a8e166a5160.jpg";